// @flow
import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'ramda/es/isEmpty';
import length from 'ramda/es/length';

import useUserTimeZone from 'app/common/hooks/useUserTimeZone';
import EmptyWarn from 'app/common/layouts/EmptyWarn';
import RowLayout from 'app/common/layouts/RowLayout';

import OrdersLoader from '../OrdersLoader';
import { OrdersContext } from '../OrdersData';
import Order from './Order';


type Props = {
  onRedirectToCart?: () => void,
}

const OrdersHistoryList = ({ onRedirectToCart }: Props) => {
  const { t } = useTranslation('shop');
  const [timezone, loadingTimezone] = useUserTimeZone();

  const {
    loading: { orders: loadingOrders },
    content: { orders, count },
    request: { ordersNext },
  } = useContext(OrdersContext);

  const nothing = isEmpty(orders);
  const loading = loadingOrders;
  const notAllOrdersShown = length(orders) < count;

  return (
    <Fragment>
      {nothing
        && !loading
        && <RowLayout>
          <EmptyWarn>{t('my_orders_empty')}</EmptyWarn>
        </RowLayout>}

      {orders.map(({ id, number, date }, i) => (
        <Order
          key={id}
          id={id}
          number={number}
          date={date}
          timezone={timezone}
          loading={loadingTimezone}
          noIntroSpace={i === 0}
          onRedirectToCart={onRedirectToCart}
        />
      ))}

      <OrdersLoader
        loading={loading}
        onVisible={ordersNext}
        disable={!notAllOrdersShown}
      />

    </Fragment>
  );
};

export default OrdersHistoryList;
